import { render, staticRenderFns } from "./studyTaskDetails.vue?vue&type=template&id=4b26a74d&scoped=true"
import script from "./studyTaskDetails.ts?vue&type=script&lang=js&external"
export * from "./studyTaskDetails.ts?vue&type=script&lang=js&external"
import style0 from "./studyTaskDetails.vue?vue&type=style&index=0&id=4b26a74d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b26a74d",
  null
  
)

export default component.exports